import { Button } from "components/Button";
import { Select } from "components/Select";
import { Form } from "formik";
import type { ThemeProps } from "models/styles/theme";
import styled, { css } from "styled-components/macro";

import { Heading3, Heading4Css } from "styles/elements/Headings";
import { ParagraphLarge } from "styles/elements/Texts";
import { calculateRem } from "styles/mixins/calculateRem";

export const StyledField = styled.div<ThemeProps>`
  display: flex;
  flex-direction: column;
  max-width: ${calculateRem(410)};
  label {
    margin-bottom: 0.5rem;
    margin-top: 0.5rem;
    font-weight: ${({ theme }: ThemeProps) => theme.font.weight.bold};
  }
`;

const labelCss = css`
  ${Heading4Css}
  display: block;
  margin: 0.5rem 0;
`;

export const FormLabel = styled.label`
  ${labelCss}
`;

export const StyledForm = styled(Form)`
  ${Heading3} {
    margin-bottom: 1rem;
  }

  ${ParagraphLarge} {
    margin-bottom: 1.5rem;
  }

  button {
    height: 3rem;
  }
`;

export const StyledSelect = styled(Select)`
  width: ${calculateRem(410)};
`;

export const StyledButton = styled(Button)<ThemeProps>`
  font-size: ${({ theme }: ThemeProps) => theme.font.size._16};
  font-weight: ${({ theme }: ThemeProps) => theme.font.weight.bold};
  margin-top: ${calculateRem(40)};
  margin-right: ${calculateRem(20)};
`;

export const StyledEducationButton = styled(Button)<ThemeProps>`
  font-size: ${({ theme }: ThemeProps) => theme.font.size._16};
  font-weight: ${({ theme }: ThemeProps) => theme.font.weight.bold};
`;
